module.exports = __webpack_public_path__ + "img/1585849233922502132.583724de.png";